export const CHANGE_CURRENT_URL_PARAM = 'CHANGE_CURRENT_URL_PARAM';